import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { ChevronRightIcon } from '@/icons';
import { classes } from './utils';

export interface PlatformCardProps {
  description: string;
  icon: ReactNode;
  tileClassName: string;
  title: string;
  onClick: () => void;
}

export default function PlatformCard({
  icon,
  title,
  description,
  tileClassName,
  onClick,
}: PlatformCardProps) {
  return (
    <button type="button" className={classes.card} onClick={onClick}>
      <span className={twMerge(classes.tile, tileClassName)}>{icon}</span>
      <div className={classes.info}>
        <div className={classes.title}>{title}</div>
        <div className={classes.description}>{description}</div>
      </div>
      <ChevronRightIcon className={classes.chevron} strokeWidth={2.4} />
    </button>
  );
}
